import { NO_TOTAL_NUMBERS } from '../../config/Game';

import DrawItem from './Draw.item'; 

const DrawGrid = () => {
  return ( 
    <>
      { 
        [...new Array(NO_TOTAL_NUMBERS)].map((_el, _index) => (
          <DrawItem index={_index} key={`DrawNumber${_index}`}/>
        ))  
      }
    </> 
  )
}

export default DrawGrid;